import {Pipeline, ProvisionPipelineInput} from '../types';

// FNP-1017: seed the provision form from an EXISTING pipeline — "copy/clone from
// an existing pipeline exists as an alternative to re-picking options". Reuse on
// this platform is copy/clone of a real definition, deliberately NOT a template
// layer (retired: every PIPELINE_TEMPLATE record was unreachable, and there were
// zero in test and prod).
//
// `id`, `pipelineStatus`, `stackName` and `originalStackName` are deliberately NOT
// copied — they identify the SOURCE pipeline's own provisioned resources, and
// carrying them onto a new pipeline would point the clone's teardown at the
// original's stacks. `name` is suffixed because pipeline names are unique.
export const cloneValuesFrom = (
    sourcePipeline?: Pipeline,
): ProvisionPipelineInput | undefined => sourcePipeline && {

    repositoryName: sourcePipeline.codeRepositoryName ?? '',
    branchName: sourcePipeline.branchName ?? undefined,
    name: sourcePipeline.name ? `${sourcePipeline.name}-copy` : '',
    pipelineType: sourcePipeline.pipelineType ?? undefined,
    buildCommand: sourcePipeline.buildCommand ?? undefined,
    // Stages are spread WHOLE so no per-stage field is silently dropped by a
    // clone. Note console-app's PipelineStage carries no `stackName`: that is
    // injected server-side per DEPLOY stage and consumed by
    // pipeline-cft-builder (stage.stackName ?? `${stackPrefix}-${stage.name}`),
    // which is also what stackNamesByEnv derives teardown targets from. The
    // client neither sends nor strips it, so that enrichment path is untouched.
    stages: (sourcePipeline.stages ?? []).map((stage) => ({...stage})),
    deploymentAccountGroupId: sourcePipeline.deploymentAccountGroupId ?? undefined,
    deploymentAccounts: (sourcePipeline.deploymentAccounts ?? []).map((a) => ({...a})),
    description: sourcePipeline.description ?? '',
};
